import store from '../../store';
import {loadGrants} from "@dealer-group/dealerui";

export default function ({next, router}) {

    if (!! store.state.Auth.token === true) {
        return loadGrants().then(() => next());
    }

    return router.push({name: 'Login'});
}